<template>
  <span class="has-text-weight-bold" :class="presenter.class">{{ presenter.label }}</span>
</template>

<script>
export default {
  computed: {
    presenter () {
      const presenter = {}
      if (this.invite.accepted_at) {
        presenter.class = 'has-text-success'
        presenter.label = 'Accepted'
      } else if (this.invite.rejected_at) {
        presenter.class = 'has-text-grey-light'
        presenter.label = 'Ignored'
      } else if (this.invite.canceled_at) {
        presenter.class = 'has-text-grey-light'
        presenter.label = 'Canceled'
      } else {
        presenter.class = 'has-text-grey-light'
        presenter.label = 'Pending'
      }
      return presenter
    }
  },
  props: ['invite']
}
</script>
